import {
  everyQuestionHas,
  registerInteraction,
} from "@/components/OliverBotV2/interactions/registry";
import ChoiceCard from "./ChoiceCard.vue";

registerInteraction("choice", {
  component: ChoiceCard,
  accepts: (card) => everyQuestionHas(card, "options"),
});
